import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const TunisiaFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_16059'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_16059)'>
				<rect
					width='20'
					height='14'
					fill='#E92434'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M14.2863 7.00005C14.2863 9.31965 12.3675 11.2 10.0006 11.2C7.63362 11.2 5.71484 9.31965 5.71484 7.00005C5.71484 4.68045 7.63362 2.80005 10.0006 2.80005C12.3675 2.80005 14.2863 4.68045 14.2863 7.00005ZM8.57199 7.00005C8.57199 8.5516 9.76065 9.83107 11.2942 10.0116C10.8965 10.1759 10.4593 10.2667 10.0006 10.2667C8.15961 10.2667 6.66722 8.80418 6.66722 7.00005C6.66722 5.19592 8.15961 3.73338 10.0006 3.73338C10.4593 3.73338 10.8965 3.82421 11.2942 3.98852C9.76065 4.16903 8.57199 5.4485 8.57199 7.00005ZM10.8073 8.85861L11.6821 7.81912L12.9701 8.29066L12.2317 7.15403L13.0873 6.09927L11.7561 6.43628L10.9969 5.31286L10.9125 6.65778L9.58771 7.01823L10.8668 7.51242L10.8073 8.85861Z'
					fill='white'
				/>
			</g>
		</svg>
	);
};

export default TunisiaFlagIcon;
